module.exports = __webpack_public_path__ + "img/grey-Bg.f68c3cb2.svg";